import { jwtDecode } from 'jwt-decode';
import { User } from '../api/models/User';

export const getUserData = (token: string): User => jwtDecode(token);
